<div class="timesheet__actions flex items-center gap-xs">
  <ng-content></ng-content>
  @if (timesheet.canEdit || timesheet.canApprove) {
    <a
      sb-icon-button
      [color]="'transparent'"
      [routerLink]="['', { outlets: { modal: ['timesheet', timesheet.id, 'edit'] } }]"
      [attr.aria-label]="'Edit' | translate"
    >
      <sb-icon name="pencil-regular" />
    </a>
  }

  @if (timesheet.canApprove) {
    <sb-status-button
      [status]="timesheet.status"
      (statusChange)="changeStatus($event)"
      [saving]="timesheet.saving"
      class="focus:children:outline-0"
    ></sb-status-button>
  }
  <!-- focus:children:outline-0 is a temp soltion to remove outline from button in timesheets, see https://differentlab.atlassian.net/browse/SHB-6479 -->
  @if (!timesheet.canApprove) {
    <sb-status-icon [status]="timesheet.status" [saving]="timesheet.saving"></sb-status-icon>
  }
</div>

<timesheet-total
  [time]="time"
  [salary]="salary"
  [showSalary]="showSalary"
  [showCoc]="showCoc"
  [coc]="coc"
></timesheet-total>
